import React, { PureComponent, ComponentType, ReactNode } from 'react';

import { Repository } from 'src/components/types';

const getDisplayName = (c: ComponentType) =>
  c.displayName || c.name || 'Component';

export const withRepository =
  (repository: Repository) =>
  <P extends {}>(
    Comp: ComponentType<P>
  ): ComponentType<Omit<P, 'repository'>> =>
    class WithRepository extends PureComponent<P & { children: ReactNode }> {
      /* eslint react/sort-comp: warn */
      static WrappedComponent = Comp;
      static displayName = `WithRepository(${getDisplayName(Comp)})`;

      render() {
        return <Comp {...this.props} repository={repository} />;
      }
    };
